import React, { createContext, useContext } from "react";

import BlogStore from "../stores/BlogStore";
import ConfigStore from "../stores/ConfigStore";
import FiltersStore from "../stores/FiltersStore";
import FooterStore from "../stores/FooterStore";
import HomepageStore from "../stores/HomepageStore";
import ModalStore from "../stores/ModalStore";
import NavigationStore from "../stores/NavigationStore";
import PopupStore from "../stores/PopupStore";
import RolesStore from "../stores/RolesStore";
import TrackingStore from "../stores/TrackingStore";
import VacancyStore from "../stores/VacancyStore";
import VenuePageStore from "../stores/VenuePageStore";

// holds a reference to the store (singleton)
let store;

// create the context
export const StoreContext = createContext(undefined);

export const createStore = (hydrationData) => ({
  blogStore: new BlogStore(hydrationData?.blogStore),
  configStore: new ConfigStore(hydrationData?.configStore),
  filtersStore: new FiltersStore(hydrationData?.filtersStore),
  footerStore: new FooterStore(hydrationData?.footerStore),
  homepageStore: new HomepageStore(hydrationData?.homepageStore),
  modalStore: new ModalStore(hydrationData?.modalStore),
  navigationStore: new NavigationStore(hydrationData?.navigationStore),
  popupStore: new PopupStore(hydrationData?.popupStore),
  rolesStore: new RolesStore(hydrationData?.rolesStore),
  trackingStore: new TrackingStore(hydrationData?.trackingStore),
  vacancyStore: new VacancyStore(hydrationData?.vacancyStore),
  venuePageStore: new VenuePageStore(hydrationData?.venuePageStore),
});

// create the provider component
export const StoreProvider = function RootStoreProvider({
  children,
  hydrationData,
}) {
  // only create the store once ( store is a singleton)

  // For server side rendering always create a new store

  if (typeof window === "undefined" || !store) {
    store = createStore(hydrationData);
  }

  return (
    <StoreContext.Provider value={store}>{children}</StoreContext.Provider>
  );
};

// create the hook
export function useStores() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error("useStores must be used within StoreProvider");
  }

  return context;
}
